import { useMemo } from 'react'
import { useListReportObjects } from './useListReportObjects'

export const useGetReportObjectValues = (component, runtimeConfigValues) => {
  const { data } = useListReportObjects()

  return useMemo(() => {
    if (!component || !data) return []
    const componentRequirementProps = data?.find(ro => ro.name === component)?.requirementProps
    if (!Object.keys(componentRequirementProps ?? {})?.length) return []
    return Object.entries(componentRequirementProps).reduce((acc, [_key, value]) => {
      Object.entries(value.defaultProps).forEach(([key, defaultVal]) => {
        acc[key] = {
          ...defaultVal,
          ...runtimeConfigValues?.[key]
        }
      })
      return acc
    }, {})
  }, [data, component, runtimeConfigValues])
}
